import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { ChevronLeft as ChevronLeftIcon, X as XIcon } from "lucide-react";
import IconButton from "components/crm/ui/IconButton";
import useText from "hooks/useText";

// Centred window (600 wide).
const Modal = ({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  width = 600,
  back,
}) => {
  const { text } = useText("crmUi");
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);
  if (!open) return null;
  return createPortal(
    <div
      data-testid="modal-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink/40 p-6"
      onClick={onClose}
    >
      <div
        className="flex max-h-full flex-col rounded-2xl bg-white shadow-pop"
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex items-start gap-4 px-6 pt-6">
          <div className="min-w-0 flex-1">
            {back && (
              <button
                type="button"
                onClick={back.onClick}
                className="mb-3 inline-flex items-center gap-1 rounded-md border border-line px-2 py-1 text-xs font-medium text-body hover:bg-gray-50"
              >
                <ChevronLeftIcon size={14} /> {back.label}
              </button>
            )}
            <h2 className="font-title text-xl font-semibold text-ink">{title}</h2>
            {description && (
              <p className="mt-1 text-sm text-muted">{description}</p>
            )}
          </div>
          <IconButton icon={XIcon} label={text("close")} onClick={onClose} />
        </header>
        <div className="flex min-h-0 flex-col gap-4 overflow-y-auto px-6 py-5">
          {children}
        </div>
        {footer && (
          <footer className="flex items-center justify-end gap-3 px-6 pb-6">
            {footer}
          </footer>
        )}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
